export default "__VITE_ASSET__Cr7in8hY__"